
import React from 'react';
import { connect } from 'react-redux';
import EventSource from 'eventsource';

import { bindActionCreators } from 'redux';
import * as actions_messages from '../../actions/messages.actions';
import * as actions_communications from '../../actions/communications.actions';
import * as actions_xhef from '../../actions/xhef.actions';

class Sse extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            periodTimer: 10
        }

        if (!this.source && this.props.token) {
            this.connect(this.props);
        } else if (this.source && !this.props.token) {
            this.cleanConnect();
            this.gotActivity(this.props);
        }

        console.log("SSE conecction");
    }

    shouldComponentUpdate(nextProps, nextState) {
        //console.log('shouldComponentUpdate', nextProps, this.props.token !== nextProps.token ,  this.props.xeflocal !== nextProps.xeflocal, !nextProps.token);
        if ((this.props.token !== nextProps.token || this.props.xeflocal !== nextProps.xeflocal )) {
            console.log('SSE components: ', nextProps.token, this.props.token);
            if (this.source !== undefined) {
                this.source.removeEventListener('beat', this.updateTime, false);
                this.source.removeEventListener('usuario', this.processEvent, false);
                this.source.close();
            }
            if(!!nextProps.token) {
                this.connect(nextProps);
            }
            return true
        }
        return false;
    }

    componentWillUnmount() {
        if (this.source !== undefined) {
            this.source.removeEventListener('beat', this.updateTime, false);
            this.source.removeEventListener('usuario', this.processEvent, false);
            this.source.close();
        }
    }


    gotActivity = (props) => {
        if (this.keepaliveTimer != null) {
            clearTimeout(this.keepaliveTimer);
        }
        this.keepaliveTimer = setTimeout(() => this.connect(props), 100000);
    };

    connect = (props) => {
        console.log('Connect ?: ', props.token);
        if ((!this.source || this.source.readyState === 2) && props.token) {
            const url = `${process.env.REACT_APP_API_SSE}${ props.xeflocal ? '?idLocal='+ props.xeflocal : '' }`
            console.log(`SSE connect to: ${url}`);
            this.source = new EventSource(url,
                {
                    headers: {
                        'Authorization': sessionStorage.token
                    }
                }
            );

            this.source.addEventListener('beat', (message) => { 
                this.gotActivity(props);
                this.setState({ periodTimer: 10 });
                this.processEvent(message, props, 'beat') 
            });
            this.source.addEventListener('usuario', (message) => { this.processEvent(message, props, 'usuario') });
            this.source.addEventListener('produccion', (message) => { this.processEvent(message, props, 'produccion') });
            //this.source.addEventListener('indicador', (message) => { this.processEvent(message, props, 'indicador') });

            this.source.onerror = function (err) {
                if (err) {
                    console.error(err);
                }
                if (this.source !== undefined) {
                    this.source.removeEventListener('beat', this.processEvent, false);
                    this.source.removeEventListener('usuario', this.processEvent, false);
                    this.source.removeEventListener('produccion', this.processEvent, false);
                    //this.source.removeEventListener('indicador', this.processEvent, false);
                    this.source.close();
                }
            }
            this.gotActivity(props);
        }
    }

    processEvent = (message, props, type) => {
        
        if(type !== 'beat') {
            console.log(type, message);
        }

        const events = JSON.parse(message.data);
        if(type === 'produccion') {
            props.addEvent(events)
        }
        else if (Array.isArray(events)) {
            events.forEach(function (event) {
                if (event && event.evento && event.payload instanceof Object) {
                    switch (event.evento) {
                        case 'EVT_BEAT':
                            props.xefTimeReference(event.payload.timestamp);
                            console.log('beat', event.payload.timestamp);
                            break;
                        case 'EVT_COM_CMNT':
                        case 'EVT_MSG_CMNT':
                            props.addcomment(event.payload);
                            break;
                        case 'EVT_NOT_STAT':
                            props.pendientes(event.payload.mensajesAviso, event.payload.comunicacionesAviso);
                            break;
                        case 'EVT_COM_CREA':
                        case 'EVT_COM_CLOS':
                        case 'EVT_COM_SAVE':
                        case 'EVT_COM_READ':
                        case 'EVT_COM_SEND':
                        case 'EVT_COM_EXPI':
                            props.crearComunicacion(event.payload);
                            break;
                        case 'EVT_MSG_READ':
                        case 'EVT_MSG_EXPI':
                        case 'EVT_MSG_CREA':
                        case 'EVT_MSG_LOAD':
                        case 'EVT_MSG_SAVE':
                        case 'EVT_MSG_CLOS':
                        case 'EVT_MSG_REPL':
                            props.crearMensaje(event.payload);
                            break;
                        case 'EVT_COM_DELE':
                            props.borrarComunicacion(event.payload);
                            break;
                        default:
                            return;
                    }
                }
            })
        } else {
            console.error('Is not array: ', message);
        }
    }

    render() {
        return <div />;
    }
}


const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions_messages, actions_communications, actions_xhef), dispatch);
};

export default connect(undefined, mapDispatchToProps)(Sse);




// WEBPACK FOOTER //
// ./src/components/labels/Sse.js